import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    period: Yup.string().required('Укажите период'),
    community_ids: Yup.array()
        .min(1, 'Выберите хотя бы одно сообщество')
        .required('Выберите хотя бы одно сообщество'),
});

export default validationSchema;
